import { useAppSelector } from "@web-solutions/store/types";
import React, { useEffect, useImperativeHandle, useState } from "react";

import { LocalizedString } from "@web-solutions/core/constants/remote-config";

import Analytics from "@web-solutions/module-analytics";

import { Title } from "core/ui-elements";

import { getProductsTexts } from "core/utils/products";

import { Plans } from "../plans";

import closeIcon from "./close.svg";
import classes from "./style.module.scss";
import giftBg from "../../../../apps/virtual-brainary/src/onboarding/assets/images/giftBg.svg";
import giftBgOrange from "./giftBgOrange.svg";

import { useRemoteConfig } from "@web-solutions/base-app/hooks/use-remote-config";
import getLocale from "core/localization/get-locale";

export const DownSaleOfferModal = React.forwardRef((props, ref) => {
  const {
    //@ts-ignore
    activeProduct,
    //@ts-ignore
    products,
    //@ts-ignore
    onProductClick,
    //@ts-ignore
    onButtonClick,
    //@ts-ignore
    onPayPalSubmit,
    //@ts-ignore
    highlightWords,
    //@ts-ignore
    title,
    //@ts-ignore
    onModalToggle,
  } = props;
  const [showDownSaleModal, toggleDownSaleModal] = useState(false);

  useEffect(() => {
    onModalToggle?.(showDownSaleModal);
  }, [showDownSaleModal, onModalToggle]);

  // const locale: keyof LocalizedString = useAppSelector(
  //   (state) => state.locale.locale
  // );
  const locale = getLocale();

  useEffect(() => {
    if (showDownSaleModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [showDownSaleModal]);

  //@ts-ignore
  const getHighlightedTitle = (text, highlightWords) => {
    if (!highlightWords || highlightWords.length === 0) {
      return (
        <Title level="h3" className={classes.title}>
          {text}
        </Title>
      );
    }

    //@ts-ignore
    const escapedWords = highlightWords.map((word) =>
      word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    const regex = new RegExp(`(${escapedWords.join("|")})`, "gi");

    const parts = text.split(regex);

    return (
      <Title level="h3" className={classes.title}>
        {parts.map((part: string, index: React.Key) => {
          const isHighlight = highlightWords.some(
            (word: string) => word.toLowerCase() === part.toLowerCase()
          );
          return isHighlight ? (
            <span key={index} className={classes.titleHighlight}>
              {`\n`}
              {part}
            </span>
          ) : (
            part
          );
        })}
      </Title>
    );
  };

  const closeModal = () => {
    toggleDownSaleModal(false);
    Analytics.trackEvent("special_offer_modal", "close");
  };

  useImperativeHandle(ref, () => {
    return {
      showPaymentPopup() {
        toggleDownSaleModal(true);
      },
      closePaymentPopup() {
        closeModal();
      },
    };
  }, []);

  return (
    <div
      className={`${showDownSaleModal ? classes.downsale_new : `${classes.downsale} ${classes.active}`}`}
    >
      <div
        className={`${classes.mask} ${showDownSaleModal ? "" : classes.maskHidden}`}
      ></div>
      <div
        className={`${classes.modal} ${showDownSaleModal ? "" : classes.modalHidden}`}
      >
        <div className={classes.content}>
          <button className={classes.close} onClick={closeModal}>
            <img src={closeIcon} alt="close modal icon" />
          </button>
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <img className={classes.giftBg} src={giftBg} alt="background" />

            <div className={classes.gift}></div>
            <div style={{ maxWidth: 200, zIndex: 3 }}>
              {getHighlightedTitle(title[locale], highlightWords)}
            </div>
          </div>
          <div className={classes.plansWrapper}>
            <Plans
              key={activeProduct.recurlyId}
              subtitle={""}
              activeProduct={activeProduct}
              products={products}
              onProductClick={onProductClick}
              onFixedButtonClick={onButtonClick}
              onPayPalSubmit={onPayPalSubmit}
              productsTexts={getProductsTexts(products, "")}
              showDownSaleModal={showDownSaleModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
});
